import React from "react";

interface MeridianLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
  glow?: boolean;
}

export const MeridianLogo: React.FC<MeridianLogoProps> = ({
  className = "w-6 h-6",
  glow = true,
  ...props
}) => {
  return (
    <img
      src="/meridian_for_orizonte.PNG"
      alt="Meridian Logo"
      className={`${className} object-contain transition-all duration-300 ${
        glow ? "drop-shadow-[0_0_8px_rgba(204,255,0,0.5)]" : ""
      }`}
      {...props}
    />
  );
};
export default MeridianLogo;
